import { Box } from '@mui/material';
import React from 'react';
import LogoLoader from 'src/components/LogoLoader';
import ScrollToTop from 'src/components/ScrollToTop';

export const Loader = () => (
  <Box
    position="absolute"
    zIndex="2000"
    paddingBottom={{ xs: 30, lg: 30 }}
    height="100%"
    width="100%"
    sx={{ bgcolor: 'white' }}
  >
    <ScrollToTop />
    <Box
      position="absolute"
      height="80vh"
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <LogoLoader />
    </Box>
  </Box>
);
